export default "__VITE_ASSET__BwFf5cnj__"